import React from "react";
import Track from "../../components/trackComponents/Track";

const TrackingPage = () => {
  return <Track options={false} />;
};

export default TrackingPage;
